export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

export const STORAGE_KEY = 'vote-id';

export const STAGE_API_URL = 'https://feature-poll-widget-data.elfsight.dev';
export const API_URL = 'https://widget-data.service.elfsight.com';

export const ANIMATION_SPEED_MS = 400;
